<template>
    <div class="data-api-mode">
        <div class="mode-header">
            <span>Источник данных: TestDepo API</span>
            <PrimeButton
                label="Изменить"
                class="p-button-sm p-button-outlined"
                @click="$emit('change-source')"
            />
        </div>

        <!-- Setup section -->
        <TestDepoSetup
            v-if="!hasKeys"
            :project-id="project.id"
            @fields-loaded="onFieldsLoaded"
            @needs-confirmation="$emit('needs-confirmation', $event)"
        />

        <!-- Data view when setup is complete -->
        <div v-else class="api-data-view">
            <div class="info-section">
                <h4>Данные проекта</h4>
                <p class="section-hint">
                    <i class="pi pi-info-circle"></i>
                    Данные можно добавить вручную для проверки шаблона; строки, пришедшие через API, появятся в этой же таблице.
                </p>
                <DataTableView
                    :columns="columns"
                    :project-id="project.id"
                    :editable="true"
                    :showPdfColumn="true"
                    :showActions="true"
                    @row-added="onTestRowAdded"
                    @row-updated="onTestRowUpdated"
                    @row-deleted="onTestRowDeleted"
                    @download-one="onDownloadOne"
                />
            </div>

            <!-- API Info -->
            <ApiInfo
                :project-id="project.id"
                :api-key="apiKey"
            />

        </div>
    </div>
</template>

<script>
import TestDepoSetup from './TestDepoSetup.vue';
import ApiInfo from './ApiInfo.vue';
import DataTableView from './DataTableView.vue';
import api from "@/libs/api";

export default {
    name: "DataApiMode",
    components: {
        TestDepoSetup,
        ApiInfo,
        DataTableView
    },
    props: {
        project: {
            type: Object,
            required: true
        },
        initialData: {
            type: Object,
            default: () => ({ keys: [], values: [], apiKey: null })
        }
    },
    emits: ['change-source', 'data-changed', 'needs-confirmation'],
    data() {
        return {
            columns: this.initialData.keys || [],
            apiKey: this.initialData.apiKey || null
        };
    },
    computed: {
        hasKeys() {
            return this.columns && this.columns.length > 0;
        }
    },
    watch: {
        initialData: {
            handler(data) {
                this.columns = data.keys || [];
                this.apiKey = data.apiKey || null;
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        onFieldsLoaded(data) {
            this.columns = data.keys || [];
            this.$toast.add({
                severity: 'success',
                summary: 'Успешно',
                detail: data.test_title
                    ? `Поля загружены из теста "${data.test_title}"`
                    : 'Выбранные поля применены',
                life: 3000
            });
            this.$emit('data-changed');
        },
        onTestRowAdded() {
            this.$emit('data-changed');
        },
        onTestRowUpdated() {
            this.$emit('data-changed');
        },
        onTestRowDeleted() {
            this.$emit('data-changed');
        },
        onDownloadOne(row) {
            api.downloadFileForNumber(this.project.id, row.row);
        }
    }
}
</script>

<style scoped>
.data-api-mode {
    padding: 16px;
}

.mode-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    font-weight: 600;
    font-size: 1.1rem;
}

.info-section {
    margin-bottom: 32px;
}

.info-section h4 {
    margin-bottom: 12px;
}

.section-hint {
    color: #6c757d;
    font-size: 0.9rem;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.section-hint i {
    color: #3b82f6;
}
</style>
